import { minutesToSeconds, secondsToMinutes } from "date-fns";

export const convertSecondsToDaysHoursMinutes = (seconds?: number) => {
  if (seconds === 0) {
    return { days: 0, hours: 0, minutes: 0 };
  }
  if (!seconds) {
    return { days: undefined, hours: undefined, minutes: undefined };
  }
  const totalMinutes = secondsToMinutes(seconds);
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;
  return { days, hours, minutes };
};

export const convertDaysHoursMinutesToSeconds = (
  days: number,
  hours: number,
  minutes: number,
) => {
  const minuteDays = days * 24 * 60;
  const minuteHours = hours * 60;
  const totalMinutes = minuteDays + minuteHours + minutes;
  return minutesToSeconds(totalMinutes);
};
